import { getBulkRequest } from '@app/store/bulkRequest/selectors';
import { RootState } from '@app/store/types';

// eslint-disable-next-line import/prefer-default-export
export const getRequestTasksState = (state: RootState) => getBulkRequest(state).requestTasks;
